import styled from 'styled-components';

export const RF15CourseStyles = styled.div`
  .banner {
    background: rgb(27, 31, 44);
    
    .animationWrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    picture {
      display: flex;
      justify-content: center;

      max-width: 90%;
    }

    img {
      object-position: center;
      height: auto;
    }
  }

  .courseDescriptionWrapper {
    margin-top: -4px;
    padding: 64px 0 100px;
    background: #FFC228;

    @media (max-width: 900px) {
      padding: 33px 0 56px;
    }

    .courseDescription {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;

      @media (max-width: 900px) {
        flex-direction: column;
      }

      .descriptionAnimationText {
        transform: translateX(-5%);
        opacity: 0;
        transition: 0.4s 0.4s ease-in all;

        &.active {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .textContainer {
        max-width: 590px;

        @media (max-width: 900px) {
          max-width: fit-content;
        }

        h2 {
          margin-bottom: 12px;

          font-weight: 800;
          font-size: 72px;
          line-height: 82px;
          /* identical to box height, or 114% */

          letter-spacing: 0.02em;

          @media (max-width: 500px) {
            font-size: 28px;
            line-height: 42px;
          }
        }

        .subtitle {
          margin-bottom: 32px;

          font-weight: 700;
          font-size: 22px;
          line-height: 34px;

          @media (max-width: 500px) {
            margin-bottom: 8px;

            font-size: 18px;
            line-height: 26px;
          }
        }
      }

      .imageContainerAnimationWrapper {
        transform: scale(0);

        transition: 0.4s ease-in all;

        @media (min-width: 901px) {
          transition-delay: 0.6s;
        }

        &.active {
          transform: scale(1);
        }
      }

      img {
        width: 488px;
        height: auto;

        @media (max-width: 500px) {
          width: 100%;
          height: auto;
        }
      }
    }
  }

  .programCost {
    .list {
      gap: 10px;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));

      @media (max-width: 700px) {
        flex-direction: column;
        align-items: center;

        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      }

      .listItem {
        padding: 0 !important;
      }

      .contentWrapper {
        padding: 24px;
      }

      button {
        height: 48px;
      }
    }
  }
`;
